/** @jsx jsx */
import { jsx } from '@compiled/react';
import { Text } from '@atlaskit/primitives/compiled';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIntl } from '@atlassian/jira-intl';
import { EmptyContentMenuItem } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/ui/empty-content/index.tsx';
import messages from './messages.tsx';

export function Nav4ProjectsEmptyContent() {
	const emptyProjectsMessageGalaxia = expVal('project-terminology-refresh', 'isEnabled', false)
		? messages.emptyProjectsMessageGalaxia
		: messages.emptyProjectsMessage;
	const { formatMessage } = useIntl();

	return (
		<EmptyContentMenuItem>
			<Text size="small" color="color.text.subtle">
				{formatMessage(emptyProjectsMessageGalaxia)}
			</Text>
		</EmptyContentMenuItem>
	);
}
